/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePrivacyRequest
 */
export interface UpdatePrivacyRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePrivacyRequest
     */
    privacyOptOut: boolean;
}

/**
 * Check if a given object implements the UpdatePrivacyRequest interface.
 */
export function instanceOfUpdatePrivacyRequest(value: object): value is UpdatePrivacyRequest {
    if (!('privacyOptOut' in value) || value['privacyOptOut'] === undefined) return false;
    return true;
}

export function UpdatePrivacyRequestFromJSON(json: any): UpdatePrivacyRequest {
    return UpdatePrivacyRequestFromJSONTyped(json, false);
}

export function UpdatePrivacyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePrivacyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'privacyOptOut': json['privacyOptOut'],
    };
}

export function UpdatePrivacyRequestToJSON(value?: UpdatePrivacyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'privacyOptOut': value['privacyOptOut'],
    };
}

